import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpService } from '@upkey-platform/core/core-data-access'
import { IResume } from '@upkey-platform/resumes/resumes-shared'
import { RESUME_API_URL } from './resume-api-routes'

@Injectable({
  providedIn: 'root'
})
export class ResumeService {
  constructor(private http: HttpService) {}

  getResumeById(id: string): Observable<IResume> {
    return this.http.get<IResume>(`${RESUME_API_URL.getResumes}/${id}`)
  }
}
